import { render, staticRenderFns } from "./CurveExam.vue?vue&type=template&id=b540f6d2"
import script from "./CurveExam.vue?vue&type=script&lang=js"
export * from "./CurveExam.vue?vue&type=script&lang=js"
import style0 from "./CurveExam.vue?vue&type=style&index=0&id=b540f6d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports